import PropTypes from 'prop-types';
import React, {useContext} from 'react';
import {DateTimeRenderer, TextAlignLeftRenderer} from "../SmartTableRenderers";
import ApplicationContext from "../../ApplicationContext";
import LookupField from "../../ui/lookup/LookupField";
import { SQLIndex } from '../../fms.core/constants';
import { LookupBtOrder } from '../../fms.data/lookup';

interface BtOrderLookupProps {
  onSelect: (x: LookupBtOrder) => boolean,
  disabled?: boolean,
  initialValue: string,
  onTextChange: (text:string|undefined) => void,
  lookupId?: string|undefined,
  onTabNext?: (() => boolean)|undefined,
  onTabPrevious?: (() => boolean)|undefined,
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void,
  maxLength?: number|undefined,
  searchId?: string|undefined,
  type: string,
  focusElementAfterSelect?: (x: any) => HTMLInputElement | HTMLElement | null,
}

const columnsBTL = [
  { Header: 'PRO #', accessor: 'orderNo', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 80, Cell: TextAlignLeftRenderer },
  { Header: 'Origin', accessor: 'origin', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 150, Cell: TextAlignLeftRenderer },
  { Header: 'Destination', accessor: 'destination', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 150, Cell: TextAlignLeftRenderer },
  { Header: 'Arrival Date', accessor: 'arrivalDate', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 100, Cell: DateTimeRenderer },
];

const columnsBTD = [
  { Header: 'PRO #', accessor: 'orderNo', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 80, Cell: TextAlignLeftRenderer },
  { Header: 'Pickup Location', accessor: 'pickupLoc', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 150, Cell: TextAlignLeftRenderer },
  { Header: 'Origin', accessor: 'origin', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 150, Cell: TextAlignLeftRenderer },
  { Header: 'Destination', accessor: 'destination', resizable: true, sortable: false, canBeHidden: false, visible: true, width: 150, Cell: TextAlignLeftRenderer },
]

const BtOrderLookupField = ({
  initialValue = '',
  onSelect = () => false,
  onTextChange = () => {},
  onFocus = () => { },
  disabled = false,
  lookupId = undefined,
  onTabNext = undefined,
  onTabPrevious = undefined,
  searchId = '',
  type = '',
  focusElementAfterSelect = () => null,
  ...others
}: BtOrderLookupProps) => {

  const appContext = useContext(ApplicationContext);
  let wid, col;

  if(type === 'BTD'){
    col = columnsBTD; wid='550px';
  }
  else {
    col = columnsBTL; wid='500px';
  }

  async function queryCompanies(queryString: string | null) {
    const apiResult = await appContext.api.getLookupItems(SQLIndex.BtOrderList, queryString || '', '', searchId, type);
    return apiResult?.entities ?? [];
  }

  function onCancel() {
  }

  function filter(data: Array<LookupBtOrder>, filterText: string) {
    return data.findIndex(x => x.orderNo && x.orderNo.toLowerCase().startsWith(filterText.toLowerCase()));
  }

  return (
    <LookupField
      lookupId={lookupId}
      onTabNext={onTabNext}
      onTabPrevious={onTabPrevious}
      disabled={disabled}
      query={queryCompanies}
      width={wid}
      columns={col}
      onSelect={onSelect}
      onCancel={onCancel}
      labelProp="orderNo"
      initialValue={initialValue}
      onTextChange={onTextChange}
      filter={filter}
      focusElementAfterSelect={focusElementAfterSelect}
      {...others}
    />
  );
}

BtOrderLookupField.defaultProps = {
  onSelect: () => { },
  onTextChange: () => { },
  disabled: false,
};

BtOrderLookupField.propTypes = {
  initialValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onTextChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  lookupId: PropTypes.string,
  onTabNext: PropTypes.func,
  onTabPrevious: PropTypes.func,
};


export default React.memo(BtOrderLookupField);